// extracted by mini-css-extract-plugin
export default {"container":"tettOe7TYH"};